/* ab-sort-menu: replaces the native sort select of the collection filter row with our own list.
   The real select stays in the form (hidden) and keeps the theme flow: we set its value and fire
   `input`, facets.js does the rest. facets.js swaps the sort markup after every request, so the
   list is rebuilt from the fresh select each time. Without this script the native select works. */
(function () {
  // The editor runs this file again when the section reloads: just look for the new markup.
  if (window.abSortMenuBoot) {
    window.abSortMenuBoot();
    return;
  }
  var counter = 0;
  var refocus = ''; // 'desk' or 'mob': which trigger had focus when the choice was made
  var opened = null; // the one open widget { close: fn }
  var escDown = false;

  function cap(text) {
    var t = text.replace(/\s+/g, ' ').trim();
    return t.charAt(0).toUpperCase() + t.slice(1);
  }

  function closeOpen() {
    if (opened) opened.close();
  }

  // The desktop sort form holds only sort_by, so the theme drops the chosen filters on a sort change.
  // Put the filters of the address bar into that form before the change goes out.
  function keepFilters(select) {
    var form = select.form;
    if (!form) return;
    form.querySelectorAll('[data-ab-sort-keep]').forEach(function (n) { n.remove(); });
    new URLSearchParams(window.location.search).forEach(function (v, k) {
      if (k.indexOf('filter.') !== 0) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = k;
      input.value = v;
      input.setAttribute('data-ab-sort-keep', '');
      form.appendChild(input);
    });
  }

  function build(select) {
    var box = select.closest('.select');
    if (!box || box.hasAttribute('data-ab-sort')) return;
    box.setAttribute('data-ab-sort', '');
    counter += 1;

    var kind = select.closest('.sorting') ? 'desk' : 'mob';
    var id = 'ab-sort-' + counter;
    var label = select.id ? document.querySelector('label[for="' + select.id + '"]') : null;
    if (label && !label.id) label.id = id + '-label';

    var wrap = document.createElement('div');
    wrap.className = 'ab-sort';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ab-sort__btn';
    btn.setAttribute('role', 'combobox');
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id + '-list');
    if (select.getAttribute('aria-describedby')) btn.setAttribute('aria-describedby', select.getAttribute('aria-describedby'));

    var value = document.createElement('span');
    value.className = 'ab-sort__value';
    value.id = id + '-value';
    btn.setAttribute('aria-labelledby', (label ? label.id + ' ' : '') + value.id);
    btn.appendChild(value);

    var list = document.createElement('ul');
    list.className = 'ab-sort__list';
    list.id = id + '-list';
    list.setAttribute('role', 'listbox');
    if (label) list.setAttribute('aria-labelledby', label.id);
    list.hidden = true;

    var items = Array.prototype.map.call(select.options, function (option, i) {
      var li = document.createElement('li');
      li.className = 'ab-sort__opt';
      li.id = id + '-opt-' + i;
      li.setAttribute('role', 'option');
      li.textContent = cap(option.text);
      list.appendChild(li);
      return li;
    });

    var active = -1;

    function paint() {
      items.forEach(function (li, i) {
        li.setAttribute('aria-selected', i === select.selectedIndex ? 'true' : 'false');
        li.classList.toggle('is-active', i === active);
      });
      value.textContent = items[select.selectedIndex] ? items[select.selectedIndex].textContent : '';
      if (active > -1) btn.setAttribute('aria-activedescendant', items[active].id);
      else btn.removeAttribute('aria-activedescendant');
    }

    function setActive(i) {
      active = Math.max(0, Math.min(items.length - 1, i));
      paint();
      var li = items[active];
      if (li.scrollIntoView && list.scrollHeight > list.clientHeight) li.scrollIntoView({ block: 'nearest' });
    }

    function open() {
      closeOpen();
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      opened = { close: close };
      setActive(Math.max(0, select.selectedIndex));
      // desktop: scroll the page just enough to show the whole list; no-op if it is already in view.
      // Phones keep the list inside the filter panel, so there is nothing to scroll there.
      if (window.matchMedia('(min-width: 750px)').matches) {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        list.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
      }
    }

    function close() {
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      active = -1;
      paint();
      if (opened && opened.close === close) opened = null;
    }

    function choose(i) {
      var changed = i !== select.selectedIndex;
      select.selectedIndex = i;
      close();
      if (!changed) return;
      if (kind === 'desk') keepFilters(select);
      refocus = kind;
      window.setTimeout(function () { refocus = ''; }, 5000);
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    btn.addEventListener('click', function () {
      if (list.hidden) open();
      else close();
    });

    btn.addEventListener('keydown', function (e) {
      var isOpen = !list.hidden;
      var key = e.key;
      if (key === 'Tab') {
        if (isOpen) close();
        return;
      }
      if (key === 'Escape') {
        if (isOpen) {
          escDown = true;
          e.preventDefault();
          close();
        }
        return;
      }
      if (!isOpen) {
        if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Enter' || key === ' ') {
          e.preventDefault();
          open();
        }
        return;
      }
      if (key === 'ArrowDown') setActive(active + 1);
      else if (key === 'ArrowUp') setActive(active - 1);
      else if (key === 'Home') setActive(0);
      else if (key === 'End') setActive(items.length - 1);
      else if (key === 'Enter' || key === ' ') choose(active);
      else return;
      e.preventDefault();
    });

    // The drawer closes on Escape keyup; the list takes that Escape for itself.
    btn.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && escDown) {
        escDown = false;
        e.stopPropagation();
      }
    });

    // Keep focus on the trigger while the pointer works the list.
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('.ab-sort__opt');
      if (li) choose(items.indexOf(li));
    });
    list.addEventListener('mouseover', function (e) {
      var li = e.target.closest('.ab-sort__opt');
      if (li) setActive(items.indexOf(li));
    });

    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');
    wrap.appendChild(btn);
    wrap.appendChild(list);
    box.insertAdjacentElement('afterend', wrap);
    wrap.setAttribute('data-kind', kind);
    paint();
  }

  function enhance(root) {
    root.querySelectorAll('select[name="sort_by"]').forEach(build);
    // facets.js swapped the markup while the trigger had focus: give focus back to the new one.
    if (refocus && document.activeElement === document.body) {
      var again = root.querySelector('.ab-sort[data-kind="' + refocus + '"] .ab-sort__btn');
      if (again) again.focus({ preventScroll: true });
      refocus = '';
    }
  }

  function boot() {
    var root = document.querySelector('.ab-cg');
    if (!root || root.hasAttribute('data-ab-sort-ready')) return;
    root.setAttribute('data-ab-sort-ready', '');
    enhance(root);
    new MutationObserver(function () { enhance(root); }).observe(root, { childList: true, subtree: true });
  }

  document.addEventListener('pointerdown', function (e) {
    if (opened && !e.target.closest('.ab-sort')) closeOpen();
  });

  window.abSortMenuBoot = boot;
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
